import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import {Card} from 'react-bootstrap';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import Select from 'react-select';
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";
import moment from 'moment';
import DatePicker from "react-datepicker";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

// Modal: do you want to save your record
class AdminNewCreateSchemesViewBankEMI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            scheme_name: '',
            bank_options: [
                { value: 'AMEX BANK', label: 'AMEX BANK', value1: 'ISB0000000010'},
                { value: 'AXIS BANK', label: 'AXIS BANK', value1: 'ISB0000000003'},
                { value: 'CITIBANK', label: 'CITIBANK', value1: 'ISB0000000005'},
                { value: 'HDFC Bank', label: 'HDFC Bank', value1: 'ISB0000000001'},
                { value: 'HSBC Bank', label: 'HSBC Bank', value1: 'ISB0000000007'},
                { value: 'ICICI Bank', label: 'ICICI Bank', value1: 'ISB0000000002'},
                { value: 'INDUSIND BANK', label: 'INDUSIND BANK', value1: 'ISB0000000011'},
                { value: 'KOTAK BANK', label: 'KOTAK BANK', value1: 'ISB0000000008'},
                { value: 'RBL BANK', label: 'RBL BANK', value1: 'ISB0000000013'},
                { value: 'SBI CARD', label: 'SBI CARD', value1: 'ISB0000000009'},
                { value: 'STANDARD CHARTERED BANK', label: 'STANDARD CHARTERED BANK', value1: 'ISB0000000006'},
                { value: 'YES BANK', label: 'YES BANK', value1: 'ISB0000000014'}
            ],
            month_tenure: [
                { value: 3, label: '3 months', value1: 'TR003'},
                { value: 6, label: '6 months', value1: 'TR004'},
                { value: 9, label: '9 months', value1: 'TR005'},
                { value: 12, label: '12 months', value1: 'TR006'}
            ],
            selected_bank: null,
            selected_bank_code: null,
            selected_tenure: null,
            selected_tenure_code: null,
            cashback_type: 'flat',
            pre_or_post: 'pre',
            amounter: '',
            max_amounter: '',
            define_max: false,
            is_emi: true,
            is_cashback: false,
            emiMenus:[],
            is_duplicate: null,
            party_options: [
                { value: 'Brand', label: 'Brand' },
                { value: 'Merchant', label: 'Merchant' }
            ],
            party_list: [],
            selected_party_type: null,
            selected_party: null,
            selected_party_type2: null,
            selected_party2: [{value: null, label: null}],
            upload_user_type: null,
            brand_emi: 100,
            merchant_emi: 0,
            bank_emi: 0,
            innoviti_emi: 0,
            customer_emi: 0,
            brand_cb: 100,
            merchant_cb: 0,
            bank_cb: 0,
            innoviti_cb: 0,
            customer_cb: 0,
            txn_amount: 50000,
            isCalculate: false,
            processing_fees: 0,
            roi: 0,
            effective_roi: 0,
            selectedBankValues: [],
            selectedMonthValues: [],
            selected_bank_pre: 'POST',
            party_master_name: '',
            tid: '',
            scheme_type: 'brandemi',
            user_type: 'admin',
            additional_contains: '',
            additional_terms_conditions: '',
            low_cost_subvention: '',
            emi_type: '0',
            interest_rate:'',
            start_date: '',
            end_date: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(decoded.userGroup == 1 || decoded.userGroup == '1'){
            this.setState({ 
                user_type: 'admin',
                _notificationSystem: this.refs.notificationSystem 
            });
        }
        else{
            this.setState({ 
                user_type: 'other',
                _notificationSystem: this.refs.notificationSystem 
            });
        }
        //this.getBankList();
        this.getPartyID();
        this.getAllData();
        //var _notificationSystem = this.refs.notificationSystem;
        // this.getBrandUploadedData();
    }

    getAllData(){
        axios.post(config.get('API_URL')+'/brandemi/get_promotion_scheme_data',{
            id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            let bank_options = [];
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((valuea, index) => {
                    let amounter = '';
                    let max_amounter = '';
                    let define_max = false;
                    if (valuea.brand_sub_amount == -1 || valuea.brand_sub_amount == '-1'){
                        amounter = ''
                    }
                    else{
                        amounter = valuea.brand_sub_amount
                    }
                    if (valuea.max_cashback == '0.00F'){
                        max_amounter = ''
                        define_max = false;
                    }
                    else{
                        let max_amounter_1 = valuea.max_cashback;
                        console.log(max_amounter_1);
                        max_amounter = max_amounter_1.slice(0,- 1);
                        console.log(max_amounter);
                        define_max = true;
                    }
                    let selectedBankValues= [{value: valuea.bank_name, label: valuea.bank_name}];
                    let selectedMonthValues = [];
                    // let tenurea = '';
                    if (valuea.tenure == 1 || valuea.tenure == '1'){
                        selectedMonthValues = [{value: null, label: null}];
                    }
                    else{
                        selectedMonthValues = [{value: valuea.tenure + " months", label: valuea.tenure + " months"}];
                    }
                    // if (valuea.tenure == 3 || valuea.tenure == '3'){
                    //     tenurea = 'TR003';
                    // }
                    // else if (valuea.tenure == 6 || valuea.tenure == '6'){
                    //     tenurea = 'TR004';
                    // }
                    // else if (valuea.tenure == 9 || valuea.tenure == '9'){
                    //     tenurea = 'TR005';
                    // }
                    // else if (valuea.tenure == 12 || valuea.tenure == '12'){
                    //     tenurea = 'TR006';
                    // }
                    let cashback_type = '';
                    if (valuea.brand_sub == 'Cashback'){
                        cashback_type = 'flat';
                    }
                    else{
                        cashback_type = 'percent'
                    }
                    let emi_typea = '0'
                    if (valuea.is_emi == 1 || valuea.is_emi == '1'){
                        emi_typea = '0';
                    }
                    else if(valuea.is_emi == 2 || valuea.is_emi == '2'){
                        emi_typea = '1'
                    }
                    this.setState({
                        is_cashback: valuea.is_cashback? true : false,
                        is_emi: valuea.is_emi? true : false,
                        pre_or_post: valuea.is_upfront? 'pre' : 'post',
                        scheme_type: valuea.scheme_type,
                        brand_emi: valuea.brand_emi,
                        bank_emi: valuea.bank_emi,
                        merchant_emi: valuea.merchant_emi,
                        innoviti_emi: valuea.innoviti_emi,
                        customer_emi: valuea.customer_emi,
                        brand_cb: valuea.brand_cb,
                        bank_cb: valuea.bank_cb,
                        merchant_cb: valuea.merchant_cb,
                        innoviti_cb: valuea.innoviti_cb,
                        customer_cb: valuea.customer_cb,
                        scheme_name: valuea.scheme_name,
                        selected_bank: valuea.bank_name,
                        amounter: amounter,
                        max_amounter: max_amounter,
                        selectedBankValues:selectedBankValues,
                        selectedMonthValues: selectedMonthValues,
                        selected_bank_code: valuea.issuer_bank_code,
                        selected_tenure_code: valuea.emi_tenure_code,
                        selected_tenure: valuea.tenure,
                        cashback_type: cashback_type,
                        define_max: define_max,
                        selected_bank_pre: valuea.pre_or_post,
                        processing_fees: valuea.processing_fees,
                        tid:valuea.tid,
                        additional_contains: valuea.additional_contains,
                        additional_terms_conditions: valuea.additional_terms_conditions,
                        low_cost_subvention: valuea.low_cost_subvention,
                        emi_type: emi_typea,
                        interest_rate: valuea.interest_rate,
                        start_date: valuea.start_date,
                        end_date: valuea.end_date
                    })
                });
            }
        });
    }

    getBankList(){
        axios.post(config.get('API_URL')+'/brandemi/get_bank_list',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            let bank_options = [];
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((valuea, index) => {
                    bank_options.push({value: valuea.issuer_display_name, label: valuea.issuer_display_name, value1: valuea.issuer_bank_code, value2: valuea.issuer_default_cashback_flag})
                });
                this.setState({
                    bank_options: bank_options
                })
            }
        });
    }

    updatePartyType = (valuer) => {
        if (valuer.value == 'Merchant'){
            this.handleNotificationClick("tr", 3, "Merchant schemes is under construction.");
            // this.setState({
            //     selected_party_type: valuer.value,
            //     selected_party_type2: [{value: valuer.value, label: valuer.label}],
            //     uploadDropdown: false,
            //     upload_user_type: 2,
            //     loading: true,
            //     selected_party: null,
            //     selected_party2: null,
            //     party_list: [],
            //     party_master_id: 5,
            // }, () => {
            //     this.getPartyList();
            //     this.getBrandUploadedData();
            // });
        }
        else if( valuer.value == 'Brand'){
            this.setState({
                selected_party_type: valuer.value,
                selected_party_type2: [{value: valuer.value, label: valuer.label}],
                uploadDropdown: false,
                upload_user_type: 7,
                loading: true,
                selected_party: null,
                selected_party2: [{value: null, label: null}],
                party_master_id: 5,
                party_list: []
            }, () => {
                this.getPartyList();
            });
        }
    };

    updatePartyValue = (valuer) => {
        this.setState({
            selected_party: valuer.value,
            selected_party2: [{value: valuer.value, label: valuer.label}],
            party_master_id: valuer.value,
            loading: false,
            uploadDropdown: false
        });
        
    };

    getPartyList = () => {
        const token = localStorage.usertoken;
        axios.post(config.get('API_URL')+'/brandemi/get_party_list', {
                party_type1: this.state.selected_party_type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { console.log(response);
            let party_list = [];
            this.setState({
                party_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                party_list.push({value: values.id, label: values.party_name})
            });
            this.setState({
                party_list: party_list,
                loading: false
            })
        });
    }

    getPartyName() {
        let value_str = '';
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_name',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            console.log(response.data);
            let selected_party2 = [];
            response.data.map((values, index) => {
                selected_party2.push({value: this.state.party_master_id, label: values.party_name})
                this.setState({
                    party_master_name: values.party_name
                })
            });     
            this.setState({
                selected_party2: selected_party2,
                loading: false
            })
        });
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(decoded.userGroup == 1 || decoded.userGroup == '1'){
            axios.get(config.get('API_URL') + '/brandemi/get_id_from_scheme',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    id: this.props.match.params.id,
                }
            }).then(response => {
                console.log(response.data);
                if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
                    this.setState({
                        party_master_id: 3,
                        loading: false,
                        user_id: decoded._id
                    });
                }
                else{
                    response.data.map((values, index) => {
                        this.setState({
                            party_master_id: values.update_party_master_id
                        }, () => {
                            this.getPartyName();
                        });
                    });
                    // this.setState({
                    //     party_id_mapper: response.data
                    // });
                    // $('#party_showTable').DataTable();
                    // this.setState({
                    //     loading: false,
                    //     user_id: decoded._id
                    // });
                }
            });
        }
        else{
            axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    user_id: decoded._id
                }
            }).then(response => {
                console.log(response.data);
                if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
                    this.setState({
                        party_master_id: 3,
                        loading: false,
                        user_id: decoded._id
                    });
                }
                else{
                    response.data.map((values, index) => {
                        this.setState({
                            party_master_id: values.party_id
                        }, () => {
                            this.getPartyName();
                        });
                    });
                    // this.setState({
                    //     party_id_mapper: response.data
                    // });
                    // $('#party_showTable').DataTable();
                    // this.setState({
                    //     loading: false,
                    //     user_id: decoded._id
                    // });
                }
            });
        }
        
    }


    getDuplicate(valor){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/check_duplicate_schemes',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id,
                scheme_name: this.state.scheme_name
            }
        }).then(response => {
            console.log(response.data);
            if(response.data.length === 0){
                const token = localStorage.usertoken;
                const decoded = jwt_decode(token);
                const data = new FormData();
                data.append('scheme_name', this.state.scheme_name);
                data.append('bank_name', this.state.selected_bank);
                data.append('is_emi', (this.state.is_emi? 1 : 0));
                data.append('user_type', decoded.userGroup);
                if (this.state.selected_tenure == null){
                    data.append('tenure', 1);
                }
                else{
                    data.append('tenure', this.state.selected_tenure);
                }
                data.append('party_master_id', this.state.party_master_id);
                data.append('is_cashback', (this.state.is_cashback? 1 : 0));
                data.append('user_id', decoded._id);
                data.append('brand_sub', this.state.cashback_type);
                data.append('brand_sub_amount', this.state.amounter);
                if (this.state.define_max == false){
                    data.append('max_cashback', -1);
                }
                else{
                    data.append('max_cashback', this.state.max_amounter);
                }
                if(this.state.pre_or_post == 'pre'){
                    data.append('is_upfront', 1);
                }
                else{
                    data.append('is_upfront', 0);
                }
                data.append('brand_emi', this.state.brand_emi);
                data.append('bank_emi', this.state.bank_emi);
                data.append('merchant_emi', this.state.merchant_emi);
                data.append('innoviti_emi', this.state.innoviti_emi);
                data.append('customer_emi', this.state.customer_emi);
                data.append('brand_cb', this.state.brand_cb);
                data.append('bank_cb', this.state.bank_cb);
                data.append('merchant_cb', this.state.merchant_cb);
                data.append('innoviti_cb', this.state.innoviti_cb);
                data.append('customer_cb', this.state.customer_cb);
                data.append('processing_fees', this.state.processing_fees);
                axios.post(config.get('API_URL') + "/brandemi/create_new_scheme_new", data,{
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(res => {
                    console.log(res);
                    if(res.data.data == '1' || res.data.data == 1){
                        this.handleNotificationClick("tr", 1, "Scheme added successfully");
                        this.setState({
                            isSubmit:false,
                            loading:false
                        });

                    } 
                    else {
                        this.handleNotificationClick("tr", 3, res.data.error);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        });
                    }
                })
                .catch(err => { // then print response status
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    })
                });
            }
            else{
                this.handleNotificationClick("tr", 3, "Duplicate Scheme Name");
            }
        });
    }


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        this.setState({
            open_instructions: !this.state.open_instructions
        });
        
    }

    handleChange(checked) {
        console.log(this.state.checked);
        this.setState({
            checked
        });
    }

    updateBankValues = (valuer) => {
        this.setState({
            selected_bank: valuer.value,
            selected_bank_code: valuer.value1
        });
    };

    updateTenure = (valuer) => {
        this.setState({
            selected_tenure: valuer.value,
            selected_tenure_code: valuer.value1
        });
    };

    updateDefineMaxCashback = (valuer) => {
        this.setState({
            define_max: valuer.target.checked,
        });
    };

    updateEMI(checked) {
        this.setState({
            is_emi: checked
        })
    }

    updateCashback(checked) {
        this.setState({
            is_cashback: checked
        })
    }

    updateCashbackType = e => {
        const { name, value } = e.target;
            this.setState({
                [name]: value
            });
    }

    updatePreOrPost = e => {
        const { name, value } = e.target;
            this.setState({
                [name]: value
            });
    }


    createScheme = () => {
        let vala = this.state.scheme_name;
        let kill = 0;
        this.setState({
            loading: true
        });
        const in_amounter = Number(this.state.amounter);
        const in_max_amounter = Number(this.state.max_amounter);
        console.log(isNaN(this.state.amounter));
        console.log(isNaN(this.state.max_amounter));
        console.log(in_amounter);
        console.log(in_max_amounter);
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(this.state.scheme_name === '' || this.state.scheme_name === null){
            this.handleNotificationClick("tr", 3, "Enter valid scheme name");
            kill = 1;
        }
        else if(vala.length > 40){
            this.handleNotificationClick("tr", 3, "Max 40 chars for scheme name");
            kill = 1;
        }
        if(this.state.selected_bank== null){
            this.handleNotificationClick("tr", 3, "Select bank name");
            kill = 1;
        }
        if(!this.state.is_emi && !this.state.is_cashback){
            this.handleNotificationClick("tr", 3, "Select atleast one of Avail Zero Cost EMI or Avail Cashback");
            kill = 1;
        }
        if(this.state.is_emi && this.state.selected_tenure == null){
            this.handleNotificationClick("tr", 3, "Select emi tenure");
            kill = 1;
        }
        if(isNaN(this.state.processing_fees)){
            this.handleNotificationClick("tr", 3, "Enter valid processing fees");
            kill = 1;
        }

        if(this.state.is_emi == true){
            if(isNaN(this.state.innoviti_emi) || isNaN(this.state.merchant_emi) || isNaN(this.state.bank_emi) || isNaN(this.state.brand_emi)  || isNaN(this.state.customer_emi)){
                this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
                kill = 1;
            }
            else{
                var addup = Number(this.state.innoviti_emi) + Number(this.state.merchant_emi) + Number(this.state.bank_emi) + Number(this.state.brand_emi) + Number(this.state.customer_emi);
                console.log(addup);
                if (addup == 99.99 || addup == 100 || addup == 100.00){
                    
                }
                else{
                    this.handleNotificationClick("tr", 3, "Zero cost EMI subventions should add up to 100");
                    kill = 1;
                }
            }
        }
        
        if(this.state.is_cashback == true){
            if(isNaN(this.state.innoviti_cb) || isNaN(this.state.merchant_cb) || isNaN(this.state.bank_cb) || isNaN(this.state.brand_cb) || isNaN(this.state.customer_cb)){
                this.handleNotificationClick("tr", 3, "Enter valid zero cost EMI subvention");
                kill = 1;
            }
            else{
                var addup = Number(this.state.innoviti_cb) + Number(this.state.merchant_cb) + Number(this.state.bank_cb) + Number(this.state.brand_cb) + Number(this.state.customer_cb);;
                if (addup == 99.99 || addup == 100.00 || addup == 100){
                    
                }
                else{
                    this.handleNotificationClick("tr", 3, "Cashback subventions should add up to 100");
                    kill = 1;
                }
            }
        }

        if(this.state.is_cashback && this.state.cashback_type === 'flat'){
            if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
                kill = 1;
            }
            else if(isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
                kill = 1;
            }
        }
        
        if(this.state.is_cashback && this.state.cashback_type === 'percent'){
            if(this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
                kill = 1;
            }
            else if(isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter >= 100){
                this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
                kill = 1;
            }
        }
        
        
        if(this.state.is_cashback && this.state.cashback_type === 'percent' && this.state.define_max === true){
            if (this.state.max_amounter == '' || this.state.max_amounter == null || isNaN(this.state.max_amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
                kill = 1;
            }
            else if(isNaN(this.state.max_amounter)){
                this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.max_amounter) && in_max_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
                kill = 1;
            }
        }
        
        
        if (kill == 0){
            if ((decoded.userGroup == 1 || decoded.userGroup == '1') && (this.state.selected_party == null || this.state.selected_party_type == null)){
                this.handleNotificationClick("tr", 3, "Please select a party");
                this.setState({
                    loading: false
                })
            }
            else{
                this.getDuplicate();
            }
            
        }
    }


    uploadDropdownHandler = () => {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(decoded.userGroup == 1 || decoded.userGroup == '1'){
            this.props.history.push('/admin/admin-new-schemes-list')
        }
        else{
            this.props.history.push('/admin/new-schemes-master')
        }
    }

    toggleCalculate = () => { 
        var kill = 0;
        this.setState({
            loading: true
        });
        const in_amounter = Number(this.state.amounter);
        const in_max_amounter = Number(this.state.max_amounter);
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(this.state.scheme_type === 'bankemi'){
            this.handleNotificationClick("tr", 3, "Not applicable for BankEMI");
            kill = 1;
            return;
        }
        if(this.state.scheme_type === 'freeemi'){
            this.handleNotificationClick("tr", 3, "Not applicable for FreeEMI");
            kill = 1;
            return;
        }
        if(this.state.scheme_name === '' || this.state.scheme_name === null){
            this.handleNotificationClick("tr", 3, "Enter valid scheme name");
            kill = 1;
        }
        if(this.state.selected_bank== null){
            this.handleNotificationClick("tr", 3, "Select bank name");
            kill = 1;
        }
        if(!this.state.is_emi && !this.state.is_cashback){
            this.handleNotificationClick("tr", 3, "Select atleast one of Avail Zero Cost EMI or Avail Cashback");
            kill = 1;
        }
        if(this.state.is_emi && this.state.selected_tenure == null){
            this.handleNotificationClick("tr", 3, "Select emi tenure");
            kill = 1;
        }
        if(isNaN(this.state.processing_fees)){
            this.handleNotificationClick("tr", 3, "Enter valid processing fees");
            kill = 1;
        }
        if(this.state.is_cashback && this.state.cashback_type === 'flat'){
            if (this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
                kill = 1;
            }
            else if(isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid cashback amount");
                kill = 1;
            }
        }
        
        if(this.state.is_cashback && this.state.cashback_type === 'percent'){
            if(this.state.amounter === '' || this.state.amounter === null || isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
                kill = 1;
            }
            else if(isNaN(this.state.amounter)){
                this.handleNotificationClick("tr", 3, "Enter cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid cashback percentage");
                kill = 1;
            }
            else if(!isNaN(this.state.amounter) && in_amounter >= 100){
                this.handleNotificationClick("tr", 3, "Cashback percent cannot be greater than 99");
                kill = 1;
            }
        }
        
        
        if(this.state.is_cashback && this.state.cashback_type === 'percent' && this.state.define_max === true){
            if (this.state.max_amounter == '' || this.state.max_amounter == null || isNaN(this.state.max_amounter)){
                this.handleNotificationClick("tr", 3, "Enter valid maximum cashback amount");
                kill = 1;
            }
            else if(isNaN(this.state.max_amounter)){
                this.handleNotificationClick("tr", 3, "Enter max cashback value as digits");
                kill = 1;
            }
            else if(!isNaN(this.state.max_amounter) && in_max_amounter <= 0){
                this.handleNotificationClick("tr", 3, "Enter valid max cashback amount");
                kill = 1;
            }
        }
        console.log(kill);
        if(kill == 0){
            if(this.state.isCalculate == false && this.state.is_emi == true){
                axios.post(config.get('API_URL')+'/brandemi/get_emi_values', {
                    bank_code: this.state.selected_bank_code,
                    tenure_code: this.state.selected_tenure_code
                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(response => { console.log(response);
                response.data.map((values, index) => {
                    this.setState({
                        roi: values.roi,
                        effective_roi: values.effective_roi,
                        loading: false
                    }, () =>
                    this.setState({
                        isCalculate: !this.state.isCalculate
                    })
                    )
                });
            });
            }
            else{
                this.setState({
                    isCalculate: !this.state.isCalculate
                })
            }
        }
        this.setState({
            loading: false
        });
        
    }

    render() {
        console.log(this.state.party_master_id);
        console.log(this.state.cashback_type);
        console.log(this.state.isCalculate);
        let party_render = this.state.party_options;
        let party_render_list = this.state.party_list;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        let show_bank_emi = () =>{
            if(this.state.scheme_type == 'bankemi'){
                return(
                    <div className="row top-margin-10"> 
                        <div className="col-md-3">
                            <Label>EMI Tenures (in Months)</Label>
                            <Select name={"month_tenure2"}
                                // defaultValue={this.state.selectedMerchValues}
                                // onChange={this.updateTenure.bind(this)}
                                // options={month_tenure_render}
                                // placeholder="Select tenure"
                                // isDisabled={!is_emi_render}
                                // isClearable={true}
                                value={this.state.selectedMonthValues}
                                onChange={this.updateTenure.bind(this)}
                                options={month_tenure_render}
                                placeholder="Select tenure"
                                isDisabled={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <Label>Interest Rate</Label>
                            <Input id="interest_rate" disabled={true} className="maxheighter" placeholder={"Enter interest rate"} value={this.state.interest_rate} onChange={(e)=> {
                                let {interest_rate} = this.state;
                                interest_rate = e.target.value;
                                this.setState({
                                    interest_rate: interest_rate
                                })
                            }}/>
                        </div>
                        <div className=" col-sm-6 col-md-3 col-xs-12">
                            <Label>Select start date</Label>
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={Date.parse(this.state.start_date)}
                                    onChange={this.handleFromChange}
                                    minDate={new Date()}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-sm-6 col-md-3 col-xs-12">
                            <Label>Select end date</Label>
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={Date.parse(this.state.end_date)}
                                    onChange={this.handleToChange}
                                    minDate={new Date()}
                                    disabled={true}
                                />
                            </div>
                    </div>
                )
            }
        }

        let processing_feeser = () =>{
            if(decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                <div>
                <div className="row top-margin-10">
                    <div className="col-md-3">
                                
                        <Label>Processing Fees (on EMI)</Label>
                            
                        <div className="row">
                            <div className="col-md-12">  
                                <Input id="processing_fees" className="maxheighter" disabled={true} value={this.state.processing_fees} onChange={(e)=> {
                                let {processing_fees} = this.state;
                                processing_fees = e.target.value;
                                this.setState({
                                    processing_fees: processing_fees,
                                    mapField2: false
                                })
                            }}
                            />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                                    
                        <Label>TID</Label>
                            
                        <div className="row">
                            <div className="col-md-12">  
                                <Input id="tid" className="maxheighter" disabled={true} value={this.state.tid} onChange={(e)=> {
                                let {tid} = this.state;
                                tid = e.target.value;
                                this.setState({
                                    tid: tid,
                                    mapField2: false
                                })
                            }}
                            />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row top-margin-10">
                    <div className="col-md-6">
                        <FormGroup>
                            <Label for="exampleText">Charge Slip Additonal Contains</Label>
                            <Input type="textarea" disabled={true} name="text_charge" value={this.state.additional_contains} id="additional_contains" onChange={(e)=> {
                                    let {additional_contains} = this.state;
                                    additional_contains = e.target.value;
                                    this.setState({
                                        additional_contains: additional_contains,
                                        mapField2: false
                                    })
                                }}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-md-6">
                        <FormGroup>
                            <Label for="exampleText">Additional T{'&'}C</Label>
                            <Input type="textarea" disabled={true} name="text_additional" value={this.state.additional_terms_conditions} id="additional_terms_conditions" onChange={(e)=> {
                                    let {additional_terms_conditions} = this.state;
                                    additional_terms_conditions = e.target.value;
                                    this.setState({
                                        additional_terms_conditions: additional_terms_conditions,
                                        mapField2: false
                                    })
                                }}
                            />
                        </FormGroup>
                    </div>
                </div>
                </div>
                )
            }
            else{
                return(<div></div>)
            }
        }

        let party_shower = () => {
            if((decoded.userGroup == 1 && this.state.scheme_type != 'bankemi')|| (decoded.userGroup == '1' && this.state.scheme_type != 'bankemi')){
                return(
                    <div className="row top-margin-10">
                        <div className="col-md-3">
                            <Label>Select party type</Label>
                            <Select name={"party_type"}
                                defaultValue={[{value: 1, label: "Brand"}]}
                                onChange={this.updatePartyType.bind(this)}
                                options={party_render}
                                placeholder="Select party type"
                                isDisabled={true}
                                // isClearable={true}
                            />
                        </div>  
                        <div className="col-md-3">
                            <Label>Select party</Label>
                            <Select name={"party_name"}
                                value={this.state.selected_party2}
                                onChange={this.updatePartyValue.bind(this)}
                                options={party_render_list}
                                placeholder="Select party"
                                isDisabled={true}
                                // isClearable={true}
                            />
                        </div> 
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }
        

        let bank_options_render = this.state.bank_options;
        let month_tenure_render = this.state.month_tenure;
        let val_to_insert = null;
        let val_holder = null;
        let val_share = 'Share (in %)';
        if (this.state.cashback_type == 'flat'){
            val_to_insert = 'Cashback amount';
            val_holder = 'Enter amount';
        }
        else {
            val_to_insert = 'Cashback percentage';
            val_holder = 'Enter percentage';
        }
        let is_emi_render = (this.state.is_emi)? true : false;
        let is_cashback_render = (this.state.is_cashback)? true : false;
        let cashback_type_flat = (this.state.cashback_type === 'flat') ? true : false;
        let cashback_type_percent = (this.state.cashback_type === 'percent') ? true : false;
        let emi_type_zero = (this.state.emi_type === '0') ? true : false;
        let emi_type_low = (this.state.emi_type === '1') ? true : false;
        let scheme_type_brand = (this.state.scheme_type === 'brandemi') ? true : false;
        let scheme_type_exclusive = (this.state.scheme_type === 'exclusiveemi') ? true : false;
        let scheme_type_bank = (this.state.scheme_type === 'bankemi') ? true : false;
        let scheme_type_free = (this.state.scheme_type === 'freeemi') ? true : false;
        let p_type_pre = (this.state.pre_or_post === 'pre') ? true : false;
        let p_type_post = (this.state.pre_or_post === 'post') ? true : false;
        let checkboxer = (this.state.is_cashback && this.state.cashback_type == 'percent')  ? true : false;
        let max_cashbacker = (this.state.is_cashback && this.state.define_max) ? true: false;
        let merch_payback_amt = Number(this.state.txn_amount) * Number(this.state.effective_roi)/100;
        let loan_amt = 0;
        if(this.state.selected_bank_pre == 'PRE'){
            loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
        }
        else{
            loan_amt = Number(this.state.txn_amount)
        }
        let trans_amount = Number(this.state.txn_amount)
        let rate = Number(this.state.roi)/100; // one month interest 
        let time = Number(this.state.selected_tenure); // one month period 
        let pmt_val = 0;
        let total_amount = 0;
        function pmt(rate, nper, pv, fv, type) {
            // console.log(rate);
            // console.log(nper);
            // console.log(pv);
            if (!fv) fv = 0;
            if (!type) type = 0;
    
            if (rate == 0) return -(pv + fv)/nper;
            
            var pvif = Math.pow(1 + rate, nper);
            var pmt = rate / (pvif - 1) * -(pv * pvif + fv);
    
            if (type == 1) {
                pmt /= (1 + rate);
            };
            
            pmt_val = pmt.toFixed(2);
            total_amount = (pmt * time);
            pmt_val = pmt.toFixed(2);
            return pmt_val;
        }
        console.log(total_amount);

        let emi = (Number(this.state.txn_amount) * rate * Math.pow(1 + rate, time)) / (Math.pow(1 + rate, time) - 1);

        let to_display_what = () => {
            if (this.state.is_emi == true && this.state.is_cashback == false){
                console.log(this.state.selected_party2);
                return(
                    <div className="card noneshadow bordercard">
                        <div className="row">
                            <div className="col-md-6">Brand:</div>
                            <div className="col-md-6">{this.state.selected_party2[0].label}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Category:</div>
                            <div className="col-md-6">XXXXXX</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Model:</div>
                            <div className="col-md-6">XXXXXX</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Tenure:</div>
                            <div className="col-md-6">{this.state.selected_tenure + " months"}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Card Issuer:</div>
                            <div className="col-md-6">{this.state.selected_bank}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Transaction Amount:</div>
                            <div className="col-md-6">₹ {Number(this.state.txn_amount).toFixed(2)}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Merchant Payback:</div>
                            <div className="col-md-6">{Number(this.state.effective_roi) + " %"}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Merchant Payback Amount:</div>
                            <div className="col-md-6">₹ {merch_payback_amt.toFixed(2)}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Loan Amount:</div>
                            <div className="col-md-6">₹ {loan_amt.toFixed(2)}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Charges (P.A):</div>
                            <div className="col-md-6">{Number(this.state.roi).toFixed(2) + " %"}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">EMI Amount:</div>
                            <div className="col-md-6">₹ {pmt(rate/12,time,-loan_amt,0,0)}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Adv EMI:</div>
                            <div className="col-md-6">0</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">Total Amount with interest:</div>
                            <div className="col-md-6">₹ {total_amount.toFixed(2)}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">EMI convenience fees:</div>
                            <div className="col-md-6">₹ {Number(this.state.processing_fees).toFixed(2) + " + GST"}</div> 
                        </div>
                    </div>
                )
            }
            else if(this.state.is_emi == true && this.state.is_cashback == true){
                let messager = '';
                if (this.state.cashback_type == 'flat'){
                    messager = "You are eligible for ₹" + this.state.amounter + " cashback.";
                }
                else if(this.state.cashback_type == 'percent' && this.state.define_max == false){
                    messager = "You are eligible for " + this.state.amounter + "% cashback.";
                }
                else if(this.state.cashback_type == 'percent' && this.state.define_max == true){
                    messager = "You are eligible for " + this.state.amounter + "% cashback upto ₹" + this.state.max_amounter;
                }
                let transa_amount = Number(this.state.txn_amount);
                let superb = 0;
                let merch_payback_amt = 0;
                let manu = 0;
                if(this.state.pre_or_post == 'post'){
                    if(this.state.cashback_type == 'flat'){
                        superb = Number(this.state.amounter)*100/Number(this.state.txn_amount);
                        merch_payback_amt = Number(this.state.amounter);
                        loan_amt = Number(this.state.txn_amount);
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == false){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                        loan_amt = Number(this.state.txn_amount);
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == true){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                        if(merch_payback_amt > Number(this.state.max_amounter)){
                            merch_payback_amt = Number(this.state.max_amounter);
                        }
                        loan_amt = Number(this.state.txn_amount);
                    }
                    return(
                        <div className="card noshadow bordercard">
                            
                            <div className="row">
                                <div className="col-md-6">Brand:</div>
                                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Category:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Model:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Tenure:</div>
                                <div className="col-md-6">{this.state.selected_tenure + " months"}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Card Issuer:</div>
                                <div className="col-md-6">{this.state.selected_bank}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Transaction Amount:</div>
                                <div className="col-md-6">₹ {Number(this.state.txn_amount).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Merchant Payback:</div>
                                <div className="col-md-6">{this.state.effective_roi + "%"}</div>
                                {/* <div className="col-md-6">{((merch_payback_amt*100)/(Number(this.state.txn_amount))).toFixed(2) + " %"}</div> */}
                            </div>
                            <div className="row">
                                <div className="col-md-6">Merchant Payback Amount:</div>
                                <div className="col-md-6">₹ {Number(merch_payback_amt).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Loan Amount:</div>
                                <div className="col-md-6">₹ {Number(loan_amt).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Charges (P.A):</div>
                                <div className="col-md-6">{Number(this.state.roi).toFixed(2) + " %"}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">EMI Amount:</div>
                                <div className="col-md-6">₹ {pmt(rate/12,time,-loan_amt,0,0)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Adv EMI:</div>
                                <div className="col-md-6">0</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Total Amount with Interest:</div>
                                <div className="col-md-6">₹ {Number(total_amount).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">EMI convenience fees:</div>
                                <div className="col-md-6">₹ {Number(this.state.processing_fees).toFixed(2) + " + GST"}</div> 
                            </div>
                            <div className="row">
                                <div className="col-md-12">{messager}</div>
                            </div>
                            
                        </div>
                    )
                    
                }
                else{
                    
                    if(this.state.cashback_type == 'flat'){
                        transa_amount = trans_amount - Number(this.state.amounter);
                        superb = Number(this.state.amounter)*100/Number(this.state.txn_amount);
                        merch_payback_amt = Number(this.state.amounter);
                        loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == false){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                        transa_amount = trans_amount - merch_payback_amt;
                        loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == true){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                        if(merch_payback_amt > Number(this.state.max_amounter)){
                            merch_payback_amt = Number(this.state.max_amounter);
                        }
                        transa_amount = trans_amount - merch_payback_amt;
                        loan_amt = Number(this.state.txn_amount) - merch_payback_amt;
                    }
                    manu = loan_amt * Number(this.state.effective_roi)/100;
                    messager = '';
                    let true_loan_amt = (loan_amt - manu);
                    let manu1 = true_loan_amt * Number(this.state.effective_roi)/100;
                    true_loan_amt = true_loan_amt.toFixed(2);
                    return(
                        <div className="card noshadow bordercard">
                            
                            <div className="row">
                                <div className="col-md-6">Brand:</div>
                                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Category:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Model:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Tenure:</div>
                                <div className="col-md-6">{this.state.selected_tenure + " months"}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Card Issuer:</div>
                                <div className="col-md-6">{this.state.selected_bank}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Product Price:</div>
                                <div className="col-md-6">₹ {Number(this.state.txn_amount).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Instant Discount Amount:</div>
                                <div className="col-md-6">₹ {Number(merch_payback_amt).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Transaction Amount:</div>
                                <div className="col-md-6">₹ {Number(loan_amt).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Manufacturer Cashback:</div>
                                <div className="col-md-6">{this.state.effective_roi + "%"}</div>
                                {/* <div className="col-md-6">{((merch_payback_amt*100)/(Number(this.state.txn_amount))).toFixed(2) + " %"}</div> */}
                            </div>
                            <div className="row">
                                <div className="col-md-6">Manufacturer Cashback Amount:</div>
                                <div className="col-md-6">₹ {Number(manu).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Loan Amount:</div>
                                <div className="col-md-6">₹ {true_loan_amt}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Rate of Interest (P.A):</div>
                                <div className="col-md-6">{Number(this.state.roi).toFixed(2) + " %"}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Interest Amount:</div>
                                <div className="col-md-6">₹ {manu}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">EMI Amount:</div>
                                <div className="col-md-6">₹ {pmt(rate/12,time,-true_loan_amt,0,0)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">EMI convenience fees:</div>
                                <div className="col-md-6">₹ {Number(this.state.processing_fees).toFixed(2) + " + GST"}</div> 
                            </div>
                            <div className="row">
                                <div className="col-md-6">Advance EMI:</div>
                                <div className="col-md-6">0</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Total Amount with interest:</div>
                                <div className="col-md-6">₹ {Number(total_amount).toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Base Amount:</div>
                                <div className="col-md-6">₹ {Number(loan_amt).toFixed(2)}</div> 
                            </div>
                            <div className="row">
                                <div className="col-md-12">{messager}</div>
                            </div>
                            
                        </div>
                    )
                }
                
            }
            else if(this.state.is_emi == false && this.state.is_cashback == true){
                let messager = '';
                let transa_amount = Number(this.state.txn_amount);
                let superb = 0;
                let merch_payback_amt = 0;
                if (this.state.cashback_type == 'flat'){
                    messager = "You are eligible for ₹" + this.state.amounter + " cashback.";
                }
                else if(this.state.cashback_type == 'percent' && this.state.define_max == false){
                    messager = "You are eligible for " + this.state.amounter + "% cashback.";
                }
                else if(this.state.cashback_type == 'percent' && this.state.define_max == true){
                    messager = "You are eligible for " + this.state.amounter + "% cashback upto ₹" + this.state.max_amounter;
                }
                
                if(this.state.pre_or_post == 'post'){
                    if(this.state.cashback_type == 'flat'){
                        superb = Number(this.state.amounter)*100/Number(this.state.txn_amount);
                        merch_payback_amt = Number(this.state.amounter);
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == false){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == true){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                        if(merch_payback_amt > Number(this.state.max_amounter)){
                            merch_payback_amt = Number(this.state.max_amounter);
                        }
                    }
                    return(
                        <div className="card noshadow bordercard ">
                            <div className="row">
                                <div className="col-md-6">Brand:</div>
                                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Category:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Model:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Transaction Amount:</div>
                                <div className="col-md-6">₹ {transa_amount.toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Merchant Payback:</div>
                                <div className="col-md-6">{superb.toFixed(2) + " %"}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Merchant Payback Amount:</div>
                                <div className="col-md-6">₹ {merch_payback_amt.toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">{messager}</div>
                            </div>
                            
                        </div>
                    )
                }
                else{
                    if(this.state.cashback_type == 'flat'){
                        transa_amount = trans_amount - Number(this.state.amounter);
                        superb = Number(this.state.amounter)*100/Number(this.state.txn_amount);
                        merch_payback_amt = Number(this.state.amounter);
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == false){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                        transa_amount = trans_amount - merch_payback_amt;
                    }
                    else if(this.state.cashback_type == 'percent' && this.state.define_max == true){
                        superb = Number(this.state.amounter);
                        merch_payback_amt = Number(this.state.txn_amount)*superb/100;
                        if(merch_payback_amt > Number(this.state.max_amounter)){
                            merch_payback_amt = Number(this.state.max_amounter);
                        }
                        transa_amount = trans_amount - merch_payback_amt;
                    }
                    messager = '';
                    return(
                        <div className="card noshadow bordercard ">
                            <div className="row">
                                <div className="col-md-6">Brand:</div>
                                <div className="col-md-6">{this.state.selected_party2[0].label}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Category:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Model:</div>
                                <div className="col-md-6">XXXXXX</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Card Issuer:</div>
                                <div className="col-md-6">{this.state.selected_bank}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Product Price:</div>
                                <div className="col-md-6">₹ {trans_amount.toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Instant Discount:</div>
                                <div className="col-md-6">₹ {merch_payback_amt.toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Transaction Amount:</div>
                                <div className="col-md-6">₹ {transa_amount.toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">Base Amount:</div>
                                <div className="col-md-6">₹ {transa_amount.toFixed(2)}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">{messager}</div>
                            </div>
                            
                        </div>
                    )
                }
            }
        }

        return (
            <div className="content longcontent">
                <CommonNavbar/>
                <div className="container-fluid">
            <div className="card-query-builder top-pad-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <Modal isOpen={this.state.isCalculate} 
                    toggle={this.toggleCalculate.bind(this)} 
                    size = "lg"
                    >
                    <ModalBody>
                        <div className="row">
                            <div className="col-xs-12 ">
                                <h4 className="modalh4">Scheme calculation for scheme: {this.state.scheme_name}</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 ">
                                <Label>Transaction Amount:</Label>
                                <Input id="reason" className="maxheighter" placeholder={"Enter transaction amount"} value={this.state.txn_amount} onChange={(e)=> {
                                        let {txn_amount} = this.state;
                                        txn_amount = e.target.value;
                                        if((e.target.value === '-1' || isNaN(e.target.value))){
                                            this.handleNotificationClick("tr", 3, "Insert valid transaction amount");
                                        }else{
                                            this.setState({
                                                txn_amount: txn_amount
                                            })
                                        }
                                    }}/>     
                            </div>
                            <div className="col-md-9">
                                {to_display_what()}
                            </div>

                        </div>
                        <ModalFooter>
                                <Button color="primary" className="btn btn-primary btn-capitalize" onClick={this.toggleCalculate}>Cancel</Button>{' '}
                                {/* <Button color="secondary" className="btn-capitalize2" onClick={this.toggleDecampaignModel.bind(this)}>Cancel</Button> */}
                        </ModalFooter>
                    </ModalBody>
                </Modal>
                <div className="col-md-12" >
                    <div className="card">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            
                            <h4 className="title pull-left">Scheme: {this.state.scheme_name}</h4>
                            <button onClick={this.uploadDropdownHandler} className="btn-primary nowhiter notwhiter btn-capitalize3 pull-right">Go back</button>&nbsp;
                            <button onClick={this.toggleCalculate} className="btn-primary nowhiter notwhiter btn-capitalize3 pull-right">Calculate</button>&nbsp;
                        </div>
                        
                        <div className="content">
                            <div className="container-fluid">
                                {party_shower()}
                                <div className="row top-margin-10">
                                    <div className="col-md-3">
                                        <Label>Select bank</Label>
                                        <Select name={"bank_name"}
                                            value={this.state.selectedBankValues}
                                            onChange={this.updateBankValues.bind(this)}
                                            options={bank_options_render}
                                            placeholder="Select bank"
                                            isDisabled={true}
                                            // isClearable={true}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <Label>Scheme name</Label>
                                        <Input id="scheme_name" className="maxheighter" disabled={true} value={this.state.scheme_name} onChange={(e)=> {
                                            let {scheme_name} = this.state;
                                            scheme_name = e.target.value;
                                            this.setState({
                                                scheme_name: scheme_name,
                                                mapField2: false
                                            })
                                        }}/>
                                    </div>
                                    {this.state.user_type ==='admin'?
                                    <div className="col-md-6">
                                        <Label>Scheme type</Label>
                                        <div className="row">
                                            <div className="col-md-12 top-pad-5">
                                                <input className="radio-margin-8" type="radio" name="scheme_type" value="brandemi" disabled={true} checked={scheme_type_brand} onChange={this.updateCashbackType} /> BrandEMI &nbsp;&nbsp;&nbsp;
                                                <input className="radio-margin-8" type="radio" name="scheme_type" value="exclusiveemi" disabled={true} checked={scheme_type_exclusive} onChange={this.updateCashbackType} /> ExclusiveEMI &nbsp;&nbsp;&nbsp;
                                                <input className="radio-margin-8" type="radio" name="scheme_type" value="bankemi" disabled={true} checked={scheme_type_bank} onChange={this.updateCashbackType} /> BankEMI &nbsp;&nbsp;&nbsp;
                                                <input className="radio-margin-8" type="radio" name="scheme_type" value="freeemi" disabled={true} checked={scheme_type_free} onChange={this.updateCashbackType} /> FreeEMI Wallet &nbsp;&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                                </div>
                                {show_bank_emi()}
                                {this.state.scheme_type != 'bankemi'?
                                <div>
                                <div className="row top-margin-10">
                                    
                                        <div className="col-md-3">
                                            
                                                <Label>Avail EMI</Label>
                                            
                                            <div className="row">
                                                <div className="col-md-3">  
                                                    <Switch className="react-switch" disabled={true} height={20} width={38} name="isEMI" onChange={this.updateEMI.bind(this)} checked={is_emi_render}></Switch>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <Label>EMI type</Label>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <input className="radio-margin-8" type="radio" name="emi_type" disabled={true} value="0" checked={emi_type_zero} onChange={this.updateEmiType} /> Zero Cost &nbsp;&nbsp;&nbsp;
                                                    <input className="radio-margin-8" type="radio" name="emi_type" disabled={true} value="1" checked={emi_type_low} onChange={this.updateEmiType} /> Low Cost &nbsp;&nbsp;&nbsp;
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <Label>EMI Tenures (in Months)</Label>
                                            <Select name={"month_tenure"}
                                                value={this.state.selectedMonthValues}
                                                onChange={this.updateTenure.bind(this)}
                                                options={month_tenure_render}
                                                placeholder="Select tenure"
                                                isDisabled={true}
                                                // isClearable={true}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <Label>Low Cost EMI Subvention</Label>
                                            <Input id="low_cost_subvention" disabled={true} className="maxheighter" placeholder={"Enter subvention"} value={this.state.low_cost_subvention} onChange={(e)=> {
                                                let {low_cost_subvention} = this.state;
                                                low_cost_subvention = e.target.value;
                                                this.setState({
                                                    low_cost_subvention: low_cost_subvention
                                                })
                                            }}/>
                                            
                                        </div>
                                    
                                </div>
                                <div className="row top-margin-10">
                                    
                                        <div className="col-md-3">
                                            
                                                <Label>Avail Cashback</Label>
                                            
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <Switch className="react-switch" disabled={true} height={20} width={38} name="isCashback" onChange={this.updateCashback.bind(this)} checked={is_cashback_render}></Switch>
                                                </div>
                                                <div className="col-md-9">
                                                    <input className="radio-margin-8" type="radio" name="pre_or_post" disabled={true} value="pre" checked={p_type_pre} onChange={this.updatePreOrPost} />Upfront &nbsp;&nbsp;&nbsp;
                                                {/* </div>
                                                <div className="col-md-4"> */}
                                                    <input className="radio-margin-8" type="radio" name="pre_or_post" disabled={true} value="post" checked={p_type_post} onChange={this.updatePreOrPost} />Post
                                                </div>
                                            </div>                                        
                                        </div>
                                        <div className="col-md-3">
                                            
                                                <Label>Cashback type</Label>
                                            
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <input className="radio-margin-8" type="radio" name="cashback_type" disabled={true} value="flat" checked={cashback_type_flat} onChange={this.updateCashbackType} /> Flat &nbsp;&nbsp;&nbsp;
                                                    <input className="radio-margin-8" type="radio" name="cashback_type" disabled={true} value="percent" checked={cashback_type_percent} onChange={this.updateCashbackType} /> Percentage &nbsp;&nbsp;&nbsp;
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <Label>{val_to_insert}</Label>
                                            <Input id="amounter" className="maxheighter" disabled={true} placeholder={val_holder} value={this.state.amounter} onChange={(e)=> {
                                                let {amounter} = this.state;
                                                amounter = e.target.value;
                                                this.setState({
                                                    amounter: amounter
                                                })
                                            }}/>
                                            <Checkbox number={"define_max"} disabled={true} label="Define maximum cashback" onChange={this.updateDefineMaxCashback.bind(this)} checked={!!(this.state.define_max)} />
                                        </div>
                                        <div className="col-md-3">
                                            <Label>Maximum cashback amount</Label>
                                            <Input id="max_amounter" disabled={true} className="maxheighter" placeholder={"Enter amount"} value={this.state.max_amounter} onChange={(e)=> {
                                                let {max_amounter} = this.state;
                                                max_amounter = e.target.value;
                                                this.setState({
                                                    max_amounter: max_amounter
                                                })
                                            }}/>
                                        </div>
                                </div>
                                <div className="row top-margin-10">
                                    
                                        <div className="col-md-3">
                                            
                                                <Label>Subvention Participants</Label>
                                        </div>
                                </div>
                                <div className="row top-margin-10">
                                    <div className="col-md-2">
                                    
                                    </div>
                                    <div className="col-md-2">
                                        <Label>Brand(%)</Label>
                                    </div>
                                    <div className="col-md-2">
                                        <Label>Merchant(%)</Label>
                                    </div>
                                    <div className="col-md-2">
                                        <Label>Bank(%)</Label>
                                    </div>
                                    <div className="col-md-2">
                                        <Label>Innoviti(%)</Label>
                                    </div>
                                    {this.state.user_type ==='admin'?
                                    <div className="col-md-2">
                                        <Label>Customer(%)</Label>
                                    </div>
                                    : null}
                                                                              
                                </div>
                                <div className="row top-margin-10">
                                    <div className="col-md-2">
                                        <Label>Zero Cost EMI</Label>
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="brand_emi" disabled={true} className="maxheighter" placeholder={"Share (%)"} value={this.state.brand_emi} onChange={(e)=> {
                                                let {brand_emi} = this.state;
                                                brand_emi = e.target.value;
                                                this.setState({
                                                    brand_emi: brand_emi,
                                                    mapField2: false
                                                })
                                            }}/>
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="merchant_emi" disabled={true} className="maxheighter" placeholder={"Share (%)"} value={this.state.merchant_emi} onChange={(e)=> {
                                                let {merchant_emi} = this.state;
                                                merchant_emi = e.target.value;
                                                this.setState({
                                                    merchant_emi: merchant_emi,
                                                    mapField2: false
                                                })
                                            }}/>
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="bank_emi" disabled={true} className="maxheighter" placeholder={"Share (%)"} value={this.state.bank_emi} onChange={(e)=> {
                                            let {bank_emi} = this.state;
                                            bank_emi = e.target.value;
                                            this.setState({
                                                bank_emi: bank_emi,
                                                mapField2: false
                                            })
                                        }}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="innoviti_emi" disabled={true} className="maxheighter" placeholder={"Share (%)"} value={this.state.innoviti_emi} onChange={(e)=> {
                                            let {innoviti_emi} = this.state;
                                            innoviti_emi = e.target.value;
                                            this.setState({
                                                innoviti_emi: innoviti_emi,
                                                mapField2: false
                                            })
                                        }}/>
                                    </div>
                                    {this.state.user_type ==='admin'?
                                    <div className="col-md-2">
                                        <Input id="customer_emi" disabled={true} className="maxheighter" placeholder={"Share (%)"} value={this.state.customer_emi} onChange={(e)=> {
                                            let {customer_emi} = this.state;
                                            customer_emi = e.target.value;
                                            this.setState({
                                                customer_emi: customer_emi,
                                                mapField2: false
                                            })
                                        }}/>
                                    </div>
                                    : null}
                                                                              
                                </div>
                                <div className="row top-margin-10">
                                    <div className="col-md-2">
                                        <Label>Cashback</Label>
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="brand_cb" className="maxheighter" disabled={true} placeholder={val_share} value={this.state.brand_cb} onChange={(e)=> {
                                                let {brand_cb} = this.state;
                                                brand_cb = e.target.value;
                                                this.setState({
                                                    brand_cb: brand_cb,
                                                    mapField2: false
                                                })
                                            }}/>
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="merchant_cb" className="maxheighter" disabled={true} placeholder={val_share} value={this.state.merchant_cb} onChange={(e)=> {
                                                let {merchant_cb} = this.state;
                                                merchant_cb = e.target.value;
                                                this.setState({
                                                    merchant_cb: merchant_cb,
                                                    mapField2: false
                                                })
                                            }}/>
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="bank_cb" className="maxheighter" disabled={true} placeholder={val_share} value={this.state.bank_cb} onChange={(e)=> {
                                            let {bank_cb} = this.state;
                                            bank_cb = e.target.value;
                                            this.setState({
                                                bank_cb: bank_cb,
                                                mapField2: false
                                            })
                                        }}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <Input id="innoviti_cb" className="maxheighter" disabled={true} placeholder={val_share} value={this.state.innoviti_cb} onChange={(e)=> {
                                            let {innoviti_cb} = this.state;
                                            innoviti_cb = e.target.value;
                                            this.setState({
                                                innoviti_cb: innoviti_cb,
                                                mapField2: false
                                            })
                                        }}/>
                                    </div>
                                    {this.state.user_type ==='admin'?
                                    <div className="col-md-2">
                                        <Input id="customer_cb" className="maxheighter" disabled={true} placeholder={val_share} value={this.state.customer_cb} onChange={(e)=> {
                                            let {customer_cb} = this.state;
                                            customer_cb = e.target.value;
                                            this.setState({
                                                customer_cb: customer_cb,
                                                mapField2: false
                                            })
                                        }}/>
                                    </div>
                                    : null}
                                                                              
                                </div>
                                </div>
                                : null}
                                {processing_feeser()}
                                <div className="row top-margin-10">
                                    {/* <div className ="col-md-12">
                                        <button onClick={this.createScheme} className="btn btn-primary btn-capitalize pull-left">Create scheme</button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        );
    }
}

export default AdminNewCreateSchemesViewBankEMI;